import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZipcodeCheckComponent } from './zipcode-check/zipcode-check.component';
import { PanelInternetComponent } from './panel-internet/panel-internet.component';
import { PanelTelevisionComponent } from './panel-television/panel-television.component';
import { PanelComponent } from './panel/panel.component';
import { PanelMobileComponent } from './panel-mobile/panel-mobile.component';
import { PanelBaseComponent } from './panel-base/panel-base.component';
import { PanelCartComponent } from './panel-cart/panel-cart.component';
import { AlertComponent } from './components/alert/alert.component';
import { TablerIconsModule } from 'angular-tabler-icons';
import { SkeletonScreenComponent } from './skeleton-screen/skeleton-screen.component';
import { IconCheck, IconChevronsRight, IconCircleArrowDownFilled, IconCircleArrowUpFilled, IconInfoCircle, IconLoader2, IconMinus, IconPencil, IconPlus } from 'angular-tabler-icons/icons';
import { InputPanelComponent } from './components/input-panel/input-panel.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ClientOrderService, ClientPackageService } from './services';
import { PanelPhoneComponent } from './panel-phone/panel-phone.component';
import { PanelDetailsComponent } from './panel-details/panel-details.component';
import { PanelCustomerComponent } from './panel-customer/panel-customer.component';

const icons = {
  IconCheck,
  IconMinus,
  IconPlus,
  IconPencil,
  IconCircleArrowUpFilled,
  IconCircleArrowDownFilled,
  IconChevronsRight,
  IconLoader2,
  IconInfoCircle,
};

@NgModule({
  imports: [
    CommonModule,
    TablerIconsModule.pick(icons),
    ReactiveFormsModule,
    ZipcodeCheckComponent,
    PanelInternetComponent,
    PanelTelevisionComponent,
    PanelComponent,
    PanelMobileComponent,
    PanelBaseComponent,
    PanelCartComponent,
    AlertComponent,
    SkeletonScreenComponent,
    InputPanelComponent,
    PanelPhoneComponent,
    PanelDetailsComponent,
    PanelCustomerComponent,
  ],
  exports: [
    ZipcodeCheckComponent,
    PanelInternetComponent,
    PanelTelevisionComponent,
    PanelMobileComponent,
    PanelBaseComponent,
    PanelCartComponent,
    AlertComponent,
    PanelPhoneComponent,
    PanelDetailsComponent,
    PanelCustomerComponent,
  ],
  providers: [ClientPackageService, ClientOrderService],
})
export class WebmoduleOrderModule {}
